import { DatePicker } from 'antd';
import './style.scss';
export default function CustomDatePicker(props) {
	return (
		<>
			<DatePicker placeholder={props.placeholder || 'Seleccione'} {...props} />
		</>
	);
}
